import styled, { css } from 'styled-components';

import { ReactComponent as FaEye } from '../../../../assets/icons/fa-eye.svg';
import { ReactComponent as FaEyeSlash } from '../../../../assets/icons/fa-eye-slash.svg';

import { colors, spacing, typography, borderRadius, transitions } from '../../../../styles/theme';

interface PositionProps {
  isAbsolute: boolean;
  height?: number;
}

export const Container = styled.div<PositionProps>`
  width: 100%;
  position: relative;

  & + & {
    margin-top: ${spacing('2')};
  }

  ${({ isAbsolute }: PositionProps) =>
    isAbsolute === true &&
    css`
      height: ${({ height }: PositionProps) => `${height}px`};
    `}
`;

export const Label = styled.label`
  font-weight: ${typography('weights.semibold')};
  display: block;
  margin-bottom: ${spacing('2')};
`;

interface InputProps {
  error?: boolean;
}

export const Input = styled.input<InputProps>`
  width: 100%;
  height: 48px;

  font-size: 1rem;
  line-height: 20px;
  color: #212121;
  border: 1px solid ${({ error }: InputProps) => (error ? colors('danger.base') : colors('black.12'))};
  border-radius: ${borderRadius('base')};
  transition: ${transitions('fast')};
  padding: 4px ${spacing('1')};
  box-sizing: border-box;
  outline: none;
  box-shadow: 0px 3px 3px rgba(224, 224, 224, 0.3);

  ::placeholder {
    color: ${colors('black.50')};
  }

  &:focus {
    border-color: ${({ error }: InputProps) => (error ? colors('danger.base') : colors('accent.base'))};
    transition: ${transitions('fast')};
  }
`;

const iconCss = css`
  width: 15px;
  height: 15px;
  fill: ${colors('black.90')};
  margin: 50px 15px 0 0;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`;

export const FaEyeIcon = styled(FaEye)`
  ${iconCss}
`;

export const FaEyeSlashIcon = styled(FaEyeSlash)`
  ${iconCss}
`;

export const Error = styled.p<PositionProps>`
  font-size: 0.9rem;
  margin-top: 6px;
  margin-left: ${spacing('1')};
  color: ${colors('danger.base')};

  ${({ isAbsolute }: PositionProps) =>
    isAbsolute === true &&
    css`
      position: absolute;
      bottom: 0;
      margin-top: 0px;
    `}
`;
